
import React from "react";
const Repeater = () => {

    return (
        <div id="repeater">
            <h3>Repeater Widget Blocks</h3>

            <div className="imageContainer">
                <img src="/images/repeater.png" alt="Repeater" />
            </div>
            
            <p>
                With the <strong>Repeater widgets</strong> in your app, you can navigate, manage, and retrieve data from repeatable entries submitted by device users.
            </p>

            <h4>Navigation Blocks</h4>
            <p>Use these blocks to move between entries in the Repeater:</p>
            <ul>
                <li><strong>navigate to the first entry</strong> – Moves to the first entry in the Repeater.</li>
                <br />
                <li><strong>navigate to the previous entry</strong> – Moves to the entry before the current one.</li>
                <br />
                <li><strong>navigate to the next entry</strong> – Moves to the entry after the current one.</li>
                <br />
                <li><strong>navigate to the last entry</strong> – Moves to the final entry in the Repeater.</li>
                <br />
                <li><strong>navigate to entry #</strong> – Moves directly to a specific entry by its index number.</li>
            </ul>

            <h4>Entry Management Blocks</h4>
            <p>These blocks allow you to create, update, and delete entries:</p>
            <ul>
                <li><strong>create new entry</strong> – Adds a new entry to the Repeater.</li>
                <br />
                <li><strong>delete entry with confirmation</strong> – Deletes the current entry after user confirmation.</li>
                <br />
                <li><strong>save current entry</strong> – Saves changes made to the current entry.</li>
            </ul>

            <h4>Data Retrieval Blocks</h4>
            <p>Use these blocks to get information about entries:</p>
            <ul>
                <li><strong>get entries amount</strong> – Returns the total number of entries in the Repeater.</li>
                <br />
                <li><strong>get current index</strong> – Returns the index of the currently viewed or edited entry.</li>
                <br />
                <li><strong>get value of current entry</strong> – Retrieves a specific value from the currently active entry.</li>
                <br />
                <li><strong>get value of entry #</strong> – Retrieves a specific value from a specified entry by index.</li>
            </ul>

            <p>
                These blocks are essential for building dynamic forms that allow multiple submissions within a single record. They work with the Repeater widget to provide full control over entry navigation, data handling, and user interaction.
            </p>
        </div>
    )
}

export default Repeater; 
